import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dateFormat from 'dateformat'
import { toast } from 'react-toastify'
import { fetchFileDocument, fetchFileRegenerateDocument } from '../../../utilities/API/document/documentAPI'
import { DOCSTUDIO_ATTACHMENT_REPLACE_URL, DOCSTUDIO_HTML_REPLACE_URL, DOCSTUDIO_REPLACE_LIVE_URL, DOCSTUDIO_REPLACE_URL, OLD_DOCSTUDIO_ATTACHMENT_REPLACE_URL, OLD_DOCSTUDIO_HTML_REPLACE_URL, OLD_DOCSTUDIO_REPLACE_LIVE_URL, OLD_DOCSTUDIO_REPLACE_URL, UAT_DOCSTUDIO_REPLACE_URL } from '../../../constant/Constants'

export const fetchAppFileRegenerateDoc = createAsyncThunk(
    'appRegenerateDoc', fetchFileRegenerateDocument
)


const initialState = {
    isDownloaded:false,
    docList:[],
    corrList:{}
}

const regenerateDocumentSlice = createSlice({
    name: 'documentDownload',
    initialState,
    reducers: {
        resetApplicationsDocLists: (state) => {
            state.corrList={};
            state.docList=[];
            state.isDownloaded = false;
            // toast.success("Applictions reseted Successfully")
        },
        resetIsRegDownloaded:(state) =>{
            state.isDownloaded=false;
          }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppFileRegenerateDoc.pending, (state, action) => {
                // toast.warn("applications list pending")
            })
            .addCase(fetchAppFileRegenerateDoc.fulfilled, (state, action) => {
                    state.isDownloaded = true
                    let data = action.payload.res;
                    let cURL = '';   
                       if(data.ResponseDetails.URL.indexOf('https://cpr-docstudio.patientadvocate.org/') != '-1'){
                            cURL =data.ResponseDetails.URL.replace('https://cpr-docstudio.patientadvocate.org/', DOCSTUDIO_REPLACE_URL);         
                        }else if(data.ResponseDetails.URL.indexOf('https://docstudio-cpr.patientadvocate.org:8443/') != '-1'){
                            cURL =data.ResponseDetails.URL.replace('https://docstudio-cpr.patientadvocate.org:8443/', OLD_DOCSTUDIO_REPLACE_URL);
                        }else{
                            cURL =data.ResponseDetails.URL.replace('https://cpr-uat-docstudio.patientadvocate.org/', UAT_DOCSTUDIO_REPLACE_URL); 
                        } 
                    const fileName = typeof data.ResponseDetails.FileName == 'undefined' ? 'No-name' : data.ResponseDetails.FileName ;
                    fetch(cURL, {
                    method: 'GET',
                    // headers: {
                    //   'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY,
                    //   'Ocp-Apim-Trace': API_TRACE
                    // }
                    }).then(function(t) {
                    return t.blob().then((b)=>{
                        var a = document.createElement("a");
                        a.href = URL.createObjectURL(b);
                        a.setAttribute("download", fileName);
                        a.click();
                    });
                    });
            })
            .addCase(fetchAppFileRegenerateDoc.rejected, (state, action) => {
                // toast.error(action.error.message)
            })




    },
})

export const { resetApplicationsDocLists, resetIsRegDownloaded } = regenerateDocumentSlice.actions

export default regenerateDocumentSlice.reducer